/* eslint-disable default-case */
import React from 'react';
// import {  useDispatch } from 'react-redux'
import './header.css'
import { useSelector } from 'react-redux';
// import axios from 'axios';

Header.propTypes = {
};

function Header() {
    const auth = useSelector(state => state.auth);
    const { branchID } = auth.user;
    const isHCMAreaBranch = (Number(branchID) === 1 || Number(branchID) === 4 || Number(branchID) === 9 || Number(branchID) === 96);
    const isHNAreaBranch  = (Number(branchID) === 3 || Number(branchID) === 8 || Number(branchID) === 12 || Number(branchID) === 15 || Number(branchID) === 16 );

    const queryParams = window.location.href;
    const listQueryParams = queryParams.split("/");
    const checkAction = listQueryParams[3];

    function renderHeader() {
        var result = [];
        const listRender = [
            { name: "Reservation", go: '/reservation' },
            { name: "Room Cancel", go: "/cancel", },
            { name: "Room Waiting", go: "/waiting", },
            { name: "Hotel Invoice", go: "/invoice", },
        ]

        if(branchID === 1 || branchID === 4 || branchID === 9) listRender.push({ name: "Make Service Invoice", go : "/service_invoice" },)
        if(branchID === 1 || branchID === 4 || branchID === 9) listRender.push({ name: "Manager Servce Invoice", go : "/manage-service_invoice"})
        listRender.push({ name: "Company", go: "/company" })
        listRender.push({ name: "Guest Information", go: "/guest" })

        if (isHCMAreaBranch) listRender.push({ name: "Check In", go: "/checkin" }, { name: "Car Information", go: "/flight" },)
        if (isHNAreaBranch) listRender.push({ name: "Picture SI", go: "/picture-si" },)

        listRender.push({ name: "Membership Guide", go: "/membership-guide" },);
        if (branchID === 99) listRender.push({ name: "Promotion", go: "/promotion" },)

        listRender.push({ name: "Glist", go: "/glist" },);

        listRender.forEach(item => {
            result.push(<li className={item.go === checkAction ? 'nav-item active' : 'nav-item'}
                onClick={() => window.open(item.go, (item.go === "home" ? "_self" : "_blank"))}
            >
                <img src="https://res.cloudinary.com/dsm20cmen/image/upload/v1661232117/database/icon/home.svg"
                    className={item.name !== 'Reservation' ? 'op-hidden' : ''}
                    alt={"home"}
                    style={{ width: '25px', height: '35px', verticalAlign: 'middle', color: 'red' }} />
                {item.name}
            </li >)
        });
        return result;
    }

    return (
        <React.Fragment>
            {/* <ModalNotify closeModal={closeModal} /> */}
            <header className="nav-fix-top d-flex justify-content-between">
                <div>
                    <ul className="nav">
                        <span className="">
                            {renderHeader()}
                        </span>
                    </ul>
                </div>
            </header >
            <div className="range-mb-26">---</div>
        </React.Fragment >
    );
}

export default Header;